import { render, staticRenderFns } from "./receipts.vue?vue&type=template&id=00ce1040&scoped=true"
import script from "./receipts.vue?vue&type=script&lang=js"
export * from "./receipts.vue?vue&type=script&lang=js"
import style0 from "./receipts.vue?vue&type=style&index=0&id=00ce1040&prod&lang=css"
import style1 from "./receipts.vue?vue&type=style&index=1&id=00ce1040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce1040",
  null
  
)

export default component.exports